// Copyright (c) 2020 Deere & Company

import { Switch, useParams, withRouter } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import ATPTransactionLogPage from './order/atp-transaction-log';
import AllBundlesOrderedPage from './reports/all-bundles-ordered';
import AtpCalendarDetailPage from './parameters/atp-calendar-detail';
import AtpCalendarListPage from './parameters/atp-calendar-list';
import AtpCalendarPage from './parameters/atp-calendar';
import AtpReallocationPage from './parameters/atp-reallocation';
import BundleAllocationToCapacityPage from './reports/bundle-allocation-to-capacity';
import BundleAllocationToForecastPage from './reports/bundle-allocation-to-forecast';
import BundleRunningAvailabilityPage from './reports/bundle-running-availability';
import CheckAttachmentOrdersByBuildWeekPage from './constraints/check-attachment-orders-by-build-week';
import CheckOrderConstraintBuildWeeksPage from './constraints/check-orders-constraint-build-week';
import CheckOrdersOrderDetailPage from './constraints/check-orders-order-detail';
import CheckOrdersOrderSummaryPage from './constraints/check-orders-order-summary';
import ConstraintViolationsByOrderPage from './constraints/constraint-violations-by-order';
import CountingBundleEarlierOrderPage from './constraints/counting-bundle-earlier-order';
import CountingBundleRunningAvailabilityPage from './constraints/counting-bundle-running-availability';
import CountingBundleTotalAvailabilityPage from './constraints/counting-bundle-total-availability';
import FamilyBaseMachineGroupAvailabilityPage from './reports/family-base-machine-group-availability';
import FamilyCountingBundleGroupAvailabilityPage from './reports/family-counting-bundle-group-availability';
import FamilyGroupAllocationToCapacityPage from './reports/family-group-allocation-to-capacity';
import FddPastRddPage from './reports/fdd-past-rdd';
import ForecastChangePage from './reports/forecast-change';
import GroupAvailabilityPage from './reports/group-availability';
import HomePage from './home-page';
import LinkedOrderDifferencesPage from './linked-orders/linked-order-differences';
import NoBundlesOrderedPage from './reports/no-bundles-ordered';
import OF87BatchSubstitutionPage from './other/batch-substitution';
import Of06ScreenSubstitutionPage from './other/screen-substitution';
import OpenActivityAfterReallocationPage from './order/openActivityAfterReallocation';
import OpenActivityPage from './order/openActivity';
import OrderAvailabilityPage from './order/availability';
import OrderInformationPage from './order/information';
import OrderPushedOutPage from './order/pushedout';
import OrdersAvailableToShipPage from './reports/orders-available-to-ship';
import OrdersUsingBundlesByConstraintWeekPage from './reports/orders-using-bundles-by-constraint-week';
import OrdersUsingBundlesPage from './reports/orders-using-bundles';
import OrdersUsingOptionsPage from './reports/orders-using-options';
import PastDueOrdersPage from './reports/past-due-orders';
import PastDueShipmentsPage from './reports/past-due-shipments';
import PoolAvailabilityPage from './pools/pool-availability';
import PoolInventoryByPoolPkgCodePage from './pools/pool-inventory-by-pool-pkg-code';
import PoolMachineMissingStdPkgCodePage from './pools/pool-machine-missing-std-pkg-code';
import PoolOrderExchangeDetailPage from './pools/pool-order-exchange-detail';
import PoolOrderExchangesPage from './pools/pool-order-exchanges';
import PoolOrdersByPoolPkgCodePage from './pools/pool-orders-by-pool-pkg-code';
import PriorityReservationInquiryPage from './reports/priority-reservation-inquiry';
import PropTypes from 'prop-types';
import ReallocationLogPage from './order/reallocation-log';
import RegionalOrderAvailabilityPage from './reports/regional-order-availability';
import SecureRoute from '@okta/okta-react/dist/SecureRoute';
import TransactionLogPage from './order/transaction-log';
import busyCounter from './shared/reducer/busy-counter';
import { connect } from 'react-redux';
import { getUnits } from './select-units/repositories';
import { setUnit } from './shared/action-creator/unit';

function InProgress () {

    return (
        <section className="home-placeholder">
            <main>
                <div>
                    This Page is under Development!
                </div>
            </main>
        </section>
    );

}

const InvalidPage = withRouter( props => {

    props.history.push( {
        pathname: '/',
        state: {
            error: `Invalid Report: ${props.location.pathname}.  Please Select A Valid Report.`
        }
    } );

    return (
        <section className="home-placeholder">
            <main>
                <div />
            </main>
        </section>
    );

} );

export const UnitRoutes = props => {

    const { unitCode } = useParams();
    const [isValid, setIsValid] = useState( unitCode === props.unit.name );

    useEffect( () => {

        const lsUnit = localStorage.getItem( 'selectedUnit' );
        const unit = lsUnit ? JSON.parse( lsUnit ) : {};

        if ( unitCode !== props.unit.name ) {

            if ( unitCode === unit.name ) {

                localStorage.setItem( 'selectedUnit', JSON.stringify( unit ) );
                props.setUnit( unit );
                setIsValid( false );

            } else if ( props.accessToken ) {

                if ( unitCode === 'undefined' ) {

                    props.history.push( '/units' );
                    setIsValid( false );

                } else {

                    getUnits().then( response => {

                        const lst = response.find( i => i.name === unitCode );

                        if ( lst ) {

                            localStorage.setItem( 'selectedUnit', JSON.stringify( lst ) );
                            props.setUnit( lst );
                            setIsValid( false );

                        } else {

                            if ( props.history.location.pathname !== '/units' ) {

                                props.history.push( {
                                    pathname: '/units',
                                    state: {
                                        error: `Invalid Unit: ${unitCode}.  Please Select Valid Unit.`
                                    }
                                } );

                            }
                            setIsValid( false );

                        }

                    } );

                }

            } else {

                setIsValid( false );

            }

        } else {

            setIsValid( true );

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unitCode, props.unit.name, props.accessToken] );

    return (
        <>
            {isValid && (
                <Switch>
                    <SecureRoute exact path="/:unitCode" component={HomePage} />

                    {/* ORDER INFORMATION PAGES */}
                    <SecureRoute path="/:unitCode/order/availability" component={OrderAvailabilityPage} />
                    <SecureRoute path="/:unitCode/order/information" component={OrderInformationPage} />
                    <SecureRoute path="/:unitCode/order/transaction-log" component={TransactionLogPage} />
                    <SecureRoute path="/:unitCode/order/reallocation-log" component={ReallocationLogPage} />
                    <SecureRoute path="/:unitCode/order/atp-transaction-log" component={ATPTransactionLogPage} />
                    <SecureRoute path="/:unitCode/order/open-activity" component={OpenActivityPage} />
                    <SecureRoute path="/:unitCode/order/open-activity-after-reallocation" component={OpenActivityAfterReallocationPage} />
                    <SecureRoute path="/:unitCode/order/pushed-out" component={OrderPushedOutPage} />

                    {/* REPORTS PAGES */}
                    <SecureRoute path="/:unitCode/reports/orders-available-to-ship" component={OrdersAvailableToShipPage} />
                    <SecureRoute path="/:unitCode/reports/forecast-changes" component={ForecastChangePage} />
                    <SecureRoute path="/:unitCode/reports/fdd-past-rdd" component={FddPastRddPage} />
                    <SecureRoute path="/:unitCode/reports/past-due-orders" component={PastDueOrdersPage} />
                    <SecureRoute path="/:unitCode/reports/past-due-shipments" component={PastDueShipmentsPage} />
                    <SecureRoute path="/:unitCode/reports/no-bundles-ordered" component={NoBundlesOrderedPage} />
                    <SecureRoute path="/:unitCode/reports/bundle-allocation-to-capacity" component={BundleAllocationToCapacityPage} />
                    <SecureRoute path="/:unitCode/reports/bundle-allocation-to-forecast" component={BundleAllocationToForecastPage} />
                    <SecureRoute path="/:unitCode/reports/group-availability" component={GroupAvailabilityPage} />
                    <SecureRoute path="/:unitCode/reports/bundle-running-availability" component={BundleRunningAvailabilityPage} />
                    <SecureRoute path="/:unitCode/reports/family-group-allocation-capacity" component={FamilyGroupAllocationToCapacityPage} />
                    <SecureRoute path="/:unitCode/reports/all-bundles-ordered" component={AllBundlesOrderedPage} />
                    <SecureRoute path="/:unitCode/reports/priority-reservation" component={PriorityReservationInquiryPage} />
                    <SecureRoute path="/:unitCode/reports/regional-order-availability" component={RegionalOrderAvailabilityPage} />
                    <SecureRoute path="/:unitCode/reports/family-counting-bundle-group-availability" component={FamilyCountingBundleGroupAvailabilityPage} />
                    <SecureRoute path="/:unitCode/reports/orders-using-bundles" component={OrdersUsingBundlesPage} />
                    <SecureRoute path="/:unitCode/reports/family-base-machine-group-availability" component={FamilyBaseMachineGroupAvailabilityPage} />
                    <SecureRoute path="/:unitCode/reports/orders-using-options" component={OrdersUsingOptionsPage} />
                    <SecureRoute path="/:unitCode/reports/orders-using-bundles-by-constraint-week" component={OrdersUsingBundlesByConstraintWeekPage} />

                    {/* CONSTRAINT PAGES */}
                    <SecureRoute path="/:unitCode/constraints/check-orders-by-constraint-build-weeks" component={CheckOrderConstraintBuildWeeksPage} />
                    <SecureRoute path="/:unitCode/constraints/check-attachment-orders-by-build-week" component={CheckAttachmentOrdersByBuildWeekPage} />
                    <SecureRoute path="/:unitCode/constraints/constraint-violations-by-order" component={ConstraintViolationsByOrderPage} />
                    <SecureRoute path="/:unitCode/constraints/check-orders-order-summary" component={CheckOrdersOrderSummaryPage} />
                    <SecureRoute path="/:unitCode/constraints/check-orders-order-code" component={CheckOrdersOrderDetailPage} />
                    <SecureRoute path="/:unitCode/constraints/counting-bundle-earlier-order" component={CountingBundleEarlierOrderPage} />
                    <SecureRoute path="/:unitCode/constraints/counting-bundle-running-availability" component={CountingBundleRunningAvailabilityPage} />
                    <SecureRoute path="/:unitCode/constraints/counting-bundle-total-availability" component={CountingBundleTotalAvailabilityPage} />

                    {/* PARAMETERS */}
                    <SecureRoute path="/:unitCode/parameters/atp-calendar/calendar" component={AtpCalendarListPage} />
                    <SecureRoute path="/:unitCode/parameters/atp-calendar/calendar-detail" component={AtpCalendarDetailPage} />
                    <SecureRoute path="/:unitCode/parameters/atp-calendar" component={AtpCalendarPage} />
                    <SecureRoute path="/:unitCode/parameters/atp-reallocation" component={AtpReallocationPage} />

                    {/* POOL PAGES */}
                    <SecureRoute path="/:unitCode/pools/pool-availability" component={PoolAvailabilityPage} />
                    <SecureRoute path="/:unitCode/pools/pool-inventory-by-pool-pkg-code" component={PoolInventoryByPoolPkgCodePage} />
                    <SecureRoute path="/:unitCode/pools/pool-orders-by-pool-pkg-code" component={PoolOrdersByPoolPkgCodePage} />
                    <SecureRoute path="/:unitCode/pools/pool-machine-missing-std-pkg-code" component={PoolMachineMissingStdPkgCodePage} />
                    <SecureRoute path="/:unitCode/pools/pool-order-exchanges" component={PoolOrderExchangesPage} />
                    <SecureRoute path="/:unitCode/pools/pool-order-exchange-detail" component={PoolOrderExchangeDetailPage} />

                    {/* LINKED ORDERS */}
                    <SecureRoute path="/:unitCode/linked-orders/linked-order-differences" component={LinkedOrderDifferencesPage} />

                    {/* OTHER */}
                    <SecureRoute path="/:unitCode/other/batch-substitution" component={OF87BatchSubstitutionPage} />
                    <SecureRoute path="/:unitCode/other/of06-screen-substitution" component={Of06ScreenSubstitutionPage} />

                    {/* TEST PAGES */}
                    <SecureRoute path="/:unitCode/in-progress" component={InProgress} />
                    <SecureRoute path="/:unitCode/:reportName" {...props} component={InvalidPage} />
                </Switch>
            )}
        </>
    );

};

// export default UnitRoutes;

UnitRoutes.displayName = 'UnitRoutes';
UnitRoutes.propTypes = {
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    accessToken: PropTypes.string,
    isAuthenticated: PropTypes.bool,
    history: PropTypes.object,
    reports: PropTypes.object,
    setUnit: PropTypes.func.isRequired,
    unit: PropTypes.object
};
const mapStateToProps = state => ( {
    accessToken: state.oktaState.oktaState.accessToken,
    isAuthenticated: state.oktaState.oktaState.isAuthenticated,
    reports: state.application.reports,
    unit: state.application.unit
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    setUnit: unit => dispatch( setUnit( unit ) )
} );
export default connect( mapStateToProps, mapDispatchToProps )( withRouter( UnitRoutes ) );
